import clsx from 'clsx';
import { FadeIn } from 'components/common/FadeIn';
import { ReactNode } from 'react';
import styles from './Trees.module.css';

interface TreeSlideProps {
  slideNum: number;
  isActive: boolean;
  value: string;
  description: ReactNode;
  onSlideClick: (slideNum: number) => void;
  delay: number;
}

const TreeSlide = ({
  slideNum,
  isActive,
  value,
  description,
  onSlideClick,
  delay,
}: TreeSlideProps) => {
  const slideClass = `slide${slideNum}`;
  return (
    <FadeIn
      onScroll
      className={clsx(
        styles.slideWrapper,
        styles[slideClass],
        isActive ? styles.showSlideInfo : styles.hideSlideInfo,
      )}
      delay={delay}
    >
      <button
        type="button"
        onClick={() => onSlideClick(slideNum)}
        aria-label={`View slide ${slideNum}`}
      >
        <div className={clsx(styles.slide)} />
        <div className={styles.slideInfo}>
          {slideNum !== 4 && (
            <div className="daymadeTypographyLBold">{value}</div>
          )}
          <div
            className={clsx(
              'daymadeTypographyMRegular',
              styles.slideInfoDescription,
            )}
          >
            {description}
          </div>
        </div>
      </button>
    </FadeIn>
  );
};

export default TreeSlide;
